<div class="cmt-register calculation-model-register-component" [class.close]="shouldClose">
  <div class="cmt-register-container" *ngIf="newestTemplateMappingVersion">
    <steps-manager [stepsCount]="stepsCount" [currentStep]="currentStep" (onCloseClicked)="onCloseClicked()" [displayCloseButton]="true"></steps-manager>
    <div>&nbsp;</div>
    <!-- STEP 1 -->
    <section class="upload-section" [hidden]="currentStep !== 1">
      <h1>{{ 'calculationModel.registerModel' | translate }}</h1>
      <h2>{{ 'calculationModel.importFile' | translate }}</h2>
      <kendo-upload #kendoUpload [autoUpload]="false" actionsLayout="start" [restrictions]="uploadRestrictions"
                    (select)="onFileSelect(kendoUpload, $event)"
                    [batch]="false"
                    [multiple]="false">
        <ng-template kendoUploadFileTemplate let-files let-state="state">
          <label class="import-file-name-label">{{ files[0].name }}</label>

          <span class="import-mapping-version">{{newestTemplateMappingVersion.description}}</span>

          <button kendoButton (click)="onRemoveFile(kendoUpload, files[0].uid)" class="import-remove-file-btn">
            {{'import.remove' | translate}}
          </button>
        </ng-template>
      </kendo-upload>
    </section>

    <!-- STEP 2 -->
    <section class="upload-section uploaded-files-section steps-grid" [hidden]="currentStep !== 2" *ngIf="uploadedFiles.length">
      <h2>{{ 'import.importFile' | translate }}</h2>
      <kendo-grid [data]="uploadedFiles" [selectable]="{enabled: false, checkboxOnly: true}" [scrollable]="'scrollable'">
        <kendo-grid-column [field]="'fileName'" [title]="'Name'"></kendo-grid-column>
        <kendo-grid-column [field]="'fileImportGuid'" [title]="'File import Guid'"></kendo-grid-column>
        <kendo-grid-column [field]="'groupDescription'" [title]="'Group'"></kendo-grid-column>
        <kendo-grid-column [field]="'mappingVersionDescription'" [title]="'Mapping'"></kendo-grid-column>
        <kendo-grid-command-column [width]="350">
          <ng-template kendoGridCellTemplate let-dataItem>
            <button kendoButton (click)="downloadFileItem(dataItem)">{{'import.download' | translate}}</button>
            <button kendoButton (click)="prepareMapping(dataItem)">{{'calculationModel.prepareMapping' | translate}}</button>
          </ng-template>
        </kendo-grid-command-column>
      </kendo-grid>
    </section>

    <!-- STEP 3 -->
    <section class="template-edit-section steps-grid" [hidden]="currentStep !== 3">

      <kendo-grid #templateEditGrid [data]="gridData" [selectable]="{enabled: false, checkboxOnly: true}" style="height: 100%;">
        <kendo-grid-column [field]="'name'" [title]="'calculationModel.name' | translate" [headerStyle]="{'width': '40%'}" [style]="{'width': '41%'}">
          <ng-template kendoGridCellTemplate let-dataItem="dataItem">
          </ng-template>
          <ng-template kendoGridEditTemplate let-dataItem="dataItem">
            <kendo-textbox [(ngModel)]="dataItem.name"
                           name="Name">
            </kendo-textbox>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column [field]="'countryId'" [title]="'calculationModel.country' | translate" [headerStyle]="{'width': '15%'}" [style]="{'width': '15%'}">
          <ng-template kendoGridCellTemplate let-dataItem="dataItem">
          </ng-template>
          <ng-template kendoGridEditTemplate let-dataItem="dataItem">
            <kendo-dropdownlist [(ngModel)]="dataItem.countryId" [data]="countryRefList" [textField]="'description'" [valueField]="'oid'" [valuePrimitive]="true">
            </kendo-dropdownlist>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column [field]="'sectorId'" [title]="'calculationModel.sector' | translate" [headerStyle]="{'width': '15%'}" [style]="{'width': '15%'}">
          <ng-template kendoGridCellTemplate let-dataItem="dataItem">
          </ng-template>
          <ng-template kendoGridEditTemplate let-dataItem="dataItem">
            <kendo-dropdownlist [(ngModel)]="dataItem.sectorId" [data]="sectorRefList" [textField]="'description'" [valueField]="'oid'" [valuePrimitive]="true">
            </kendo-dropdownlist>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column [field]="'valuationMethodId'" [title]="'calculationModel.valuationMethod' | translate" [headerStyle]="{'width': '15%'}" [style]="{'width': '15%'}">
          <ng-template kendoGridCellTemplate let-dataItem="dataItem">
          </ng-template>
          <ng-template kendoGridEditTemplate let-dataItem="dataItem">
            <kendo-dropdownlist [(ngModel)]="dataItem.valuationMethodId" [data]="valuationMethodRefList" [textField]="'description'" [valueField]="'oid'" [valuePrimitive]="true">
            </kendo-dropdownlist>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column [field]="'statusId'" [title]="'calculationModel.status' | translate" [headerStyle]="{'width': '15%'}" [style]="{'width': '15%'}">
          <ng-template kendoGridCellTemplate let-dataItem="dataItem">
          </ng-template>
          <ng-template kendoGridEditTemplate let-dataItem="dataItem">
            <kendo-dropdownlist [(ngModel)]="dataItem.statusId" [data]="statusRefList" [textField]="'description'" [valueField]="'oid'" [valuePrimitive]="true">
            </kendo-dropdownlist>
          </ng-template>
        </kendo-grid-column>

      </kendo-grid>

    </section>


    <div class="buttons-container" *ngIf="importFiles.length || currentStep > 1">
      <button kendoButton class="prev" *ngIf="currentStep > 1" (click)="prevStep()">{{'calculationModel.back' | translate}}</button>
      <button kendoButton class="next" *ngIf="isNextEnabled() && currentStep < stepsCount" (click)="nextStep()">{{'calculationModel.next' | translate}}</button>
      <button kendoButton class="next" *ngIf="currentStep === 3" (click)="saveTemplate()">{{'calculationModel.save' | translate}}</button>
    </div>

  </div>
</div>

<ng-template #importPreviewGrid let-import='import'>
  <div class="import-grid-container" *ngIf="import.value && import.value.DataRoot && import.value.DataRoot.Data && import.value.DataRoot.Data.length">
    <kendo-grid [data]="import.value.DataRoot.Data" [scrollable]="'scrollable'">
      <kendo-grid-column *ngFor="let column of import.value.DataRoot.Data[0] | keyvalue | sortImportFields" [field]="column.key"
                         [title]="iprs.getPreviewColumnTitle(import.key, column.key)"
                         [width]="iprs.getPreviewColumnWidth(import.key, column.key)"
                         [hidden]="!iprs.shouldShowField(import.key, column.key)"
                         [format]="iprs.getFormat(import.key, column.key)">
      </kendo-grid-column>
    </kendo-grid>
  </div>
</ng-template>
